module.exports = __webpack_public_path__ + "img/csr_logo_02.8b65db23.png";